module.exports = __webpack_public_path__ + "img/pigment_4.5df6e0a7.png";